<template>
  <div class="modal-SOSSet">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">报警数据</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>

      <div class="modal-body">

        <div>
          <div style="float: right;">

            <el-select v-model="type" clearable placeholder="请选择报警类型" title="报警类型" style="width:200px;margin-right:10px">
              <el-option
                  v-for="item in typeValue"
                  :key="item[0]"
                  :label="item[1]"
                  :value="item[0]">
              </el-option>
            </el-select>

            <el-date-picker style="margin-right: 10px;width:340px;" title="起止时间"
                            v-model="startEndTime"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
            </el-date-picker>

            <el-button type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>


          </div>
          <div style="clear: both"></div>
        </div>

        <div style="height: 10px;"></div>

          <el-table  v-loading="tableLoading"  :data="tableData" :height="400" border>

            <el-table-column prop="deviceName" label="设备名称" ></el-table-column>
            <el-table-column prop="type" :formatter="getType" label="报警类型"></el-table-column>
            <el-table-column prop="location" label="位置"></el-table-column>
            <el-table-column prop="createTime" :formatter="timefilter" label="报警时间"></el-table-column>

          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


      </div>
    </div>

  </div>
</template>

<script>


import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "WangGuanData",
  data() {
    return {
      tableLoading:false,
      dataInfoShow:false,

      userCode: '',

      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      startEndTime:[],

      typeValue:[[2,'紧急按钮'],[3,'红外探测器'],[4,'门磁传感器'],[5,'水浸传感器'],[6,'网关报警'],[9,'燃气泄漏报警器'],[10,'烟雾探测器']],
      type:'',

    }
  },
  components: {

  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.type='';

      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 360);
      this.startEndTime = [start, end];

      this.getList();

    },

    closeDataInfo(){
      this.dataInfoShow =!this.dataInfoShow;
    },
    closeSelf() {
      this.$emit("closeWangGuanData");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getWangGuanData();
    },


    timefilter(row,index,column){
      return timefilters(column)
    },
    getType(row,index,column){
      var type='其他'
      this.typeValue.forEach(val=>{
        if(val[0]==column){
          type=val[1]
        }
      })
      return type
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "AlarmRecord/PageByUserCodeMesh",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          startTime: timefilters(this.startEndTime[0]),
          endTime: timefilters(this.startEndTime[1]),
          type:this.type,
        }
      }).then((response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.list;
              this.totalItems=response.data.data.total;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          })

    },




  }


}
</script>

<style lang="scss" scoped>

.modal-SOSSet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px;
      z-index: 99;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>
